<template>
  <filter-default-multiselect
    v-on="$listeners"
    v-bind="$props"
  >
    <template #default="slotProps">
      <custom-select-plates-dropdown-content
        @add="slotProps.add"
        @remove="slotProps.remove"
        :options="slotProps.options"
        :selected-options="slotProps.selectedOptions"
      />
    </template>
  </filter-default-multiselect>
</template>

<script>
import CustomSelectPlatesDropdownContent from '@kit/custom-select/custom-select-plates-dropdown-content.vue';
import FilterDefaultMultiselect from '@/components/filters/filter-default-multiselect.vue';

import defaultFilterMixin from '@/components/filters/default-filter-mixin';

export default {
  components: {
    CustomSelectPlatesDropdownContent,
    FilterDefaultMultiselect,
  },

  mixins: [defaultFilterMixin],

  props: {
    placeholder: {
      type: String,
      required: true,
    },
  },
}
</script>
